import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { DraftRequete } from '../entities/draft-requete/draft-requete.model';
import { DraftDepotRequeteService } from './draft-depot-requete.service';

@Injectable()
export class DraftRequeteResolver implements Resolve<DraftRequete> {
    constructor(
        private draftDepotRequeteService: DraftDepotRequeteService
    ) {}

    resolve(): Observable<DraftRequete> {
        return this.draftDepotRequeteService.getMyDraftRequeteDetail();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/draft-requete.resolver.ts